import { axios } from '@/lib/axios';

export const getCompanyConfig = async () => {
  const response = await axios.get('/crypto/config/all');
  return response.data;
};
